import axios from "axios";
import * as files from "../../fileUtils";
import Vue from "vue";

export default {
  name: "UploadPictureToActivityAttachment",
  components: {
    CameraComp: require("@/components/camera/camera.vue").default,
    PaginationComp1:
      require("@/components/paginationComponent/paginationComponent.vue")
        .default,
  },
  props: {
    appId: {
      type: String,
      default: "",
    },
    appKey: {
      type: String,
      default: "",
    },
    account: {
      type: String,
      default: "",
    },
    caseId: {
      type: Number,
      default: -1,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    offline: {
      type: Boolean,
      default: false,
    },
    closeAfterSave: {
      type: Boolean,
      default: false,
    },
    savePicExternally: {
      type: Function,
      default: null,
    },
    captureOnlyForFieldWorker: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showComp: function () {
      if (this.appId != null && this.appId != "") return true;

      if (this.account != null && this.caseId != null && this.account != "")
        return true;

      return false;
    },
  },
  watch: {
    showDialog: function (val) {
      if (val) this.displayCamera = true;
    },
  },
  data: function () {
    return {
      activeTab: null,
      isFieldWorker: false,
      totalPages: 1,
      pageSize: 5,
      currentPage: 1,
      paginationEnabled: false,

      showCamera: true,
      displayCamera: false,
      photoList: [],
      photoToDelete: null,
      deleteConfirmation: false,
    };
  },
  created() {
    this.$root.$on("open_upload_picture_attachment_dialog", (val) => {
      this.displayCamera = val;
    });

    let prof = this.$store.getters.getUserProfile;
    this.isFieldWorker = prof.isFieldWorker ?? false;

    if (this.captureOnlyForFieldWorker && !this.isFieldWorker)
      this.activeTab = "tab-view-pictures";
    else this.activeTab = "tab-camera";
  },
  mounted() {
    this.getPhotosList();
  },
  methods: {
    onPagination(e) {
      this.currentPage = e;
      this.getPhotosList();
    },
    tabChanged(tab) {
      this.activeTab = tab;
      if (tab == "tab-view-pictures") {
        this.getPhotosList();
        this.showCamera = false;
      } else this.showCamera = true;
    },
    photoTaken(obj) {
      let img = obj.image;
      this.processPhotos(img);
      if (this.closeAfterSave) this.closeCamera();
    },
    closeCamera() {
      this.displayCamera = false;
    },

    getPhotosList() {
      let url;
      let param;
      this.paginationEnabled = false;

      //debt management disconnection
      if (this.account != null && this.caseId != null && this.account != "") {
        url = "/DmConnection/GetAttachments";
        param = { account: this.account, caseId: this.caseId.toString() };

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post(url, param)
          .then((response) => {
            if (response.data.data.status == 0) {
              this.photoList = response.data.items.sort((a, b) =>
                a.id < b.id ? 1 : -1
              );
            }
          })
          .catch((e) => {
            this.$alertMsg(
              this.$t("messages.AttachmentGetError") + " - " + e,
              4
            );
          })
          .finally(loader.hide());
      } else if (this.appId != null && this.appId != "") {
        //Application
        url =
          `/ActivityAttachment/GetAttachments?appId=${this.appId}&includeFileData=true&pageIndex=${this.currentPage}&pageSize=${this.pageSize}` +
          (this.appKey ? `&appKey=${this.appKey}` : null);

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .get(url)
          .then((response) => {
            if (response.status == 200) {
              this.photoList = response.data.attachments.sort((a, b) =>
                a.attachmentId < b.attachmentId ? 1 : -1
              );
              this.paginationEnabled = true;
              this.totalPages = Math.round(
                response.data.totalCount / this.pageSize
              );
              //document.getElementById('tab-view-pictures').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
            } else this.paginationEnabled = false;
          })
          .catch((e) => {
            this.$alertMsg(
              this.$t("messages.AttachmentGetError") +
                " - " +
                e +
                " " +
                e.response.data,
              4
            );
            this.paginationEnabled = false;
          })
          .finally(loader.hide());
      }
    },

    processPhotos(img) {
      if (!img) return;
      let url;
      //debt management disconnection
      if (this.account != null && this.caseId != null && this.account != "") {
        url = "/DmConnection/AddPhoto";

        let parameters = {
          account: this.account,
          caseId: this.caseId.toString(),
          photoBase64: img,
        };

        if (this.savePicExternally) {
          this.savePicExternally({
            account: this.account,
            caseId: this.caseId.toString(),
            img: img,
          });
          return;
        }

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post(url, parameters)
          .then((response) => {
            if (response.data.data.status == 0)
              this.$alertMsg(this.$t("messages.PhotoSavedSuccess"), 2);
            else
              this.$alertMsg(
                this.$t("messages.PhotoSaveError") +
                  " - " +
                  response.data.data.text,
                4
              );
          })
          .catch((e) => {
            this.$alertMsg(this.$t("messages.PhotoSaveError") + " - " + e, 4);
          })
          .finally(loader.hide());
      } else if (this.appId != null && this.appId != "") {
        //Application
        url = "/ActivityAttachment/AddPhoto";

        var formData = new FormData();
        formData.append("appId", this.appId);
        formData.append("photoBase64", img);

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.$alertMsg(this.$t("messages.PhotoSavedSuccess"), 2);
          })
          .catch((e) => {
            this.$alertMsg(this.$t("messages.PhotoSaveError") + " - " + e, 4);
          })
          .finally(loader.hide());
      }
    },

    deletePicConfirmation(img) {
      this.photoToDelete = img;
      this.deleteConfirmation = true;
    },
    deleteConfirmationCancel() {
      this.photoToDelete = null;
      this.deleteConfirmation = false;
    },
    deletePicture() {
      if (this.photoToDelete == null) return;
      else var img = this.photoToDelete;

      var formData = new FormData();
      let url;
      //debt management disconnection
      if (this.account != null && this.caseId != null && this.account != "") {
        url = "/DmConnection/ProcessAttachments";

        formData.append("account", this.account);
        formData.append("caseId", this.caseId.toString());
        formData.append("deleteFiles", img.id);

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.status == 200)
              this.$alertMsg(this.$t("messages.PhotoDeletedSuccess"), 2);
          })
          .catch((e) => {
            this.$alertMsg(
              this.$t("messages.AttachmentDeletedError") + " - " + e,
              4
            );
          })
          .finally(() => {
            this.getPhotosList();
            loader.hide();
          });
      } else if (this.appId != null && this.appId != "") {
        //Application
        url = "/ActivityAttachment/SaveAttachments";
        formData.append("appId", this.appId);
        formData.append("deleteFiles", img.attachmentId);

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.status == 200)
              this.$alertMsg(this.$t("messages.PhotoDeletedSuccess"), 2);
          })
          .catch((e) => {
            this.$alertMsg(
              this.$t("messages.AttachmentDeletedError") + " - " + e,
              4
            );
          })
          .finally(() => {
            this.getPhotosList();
            loader.hide();
          });

        this.photoToDelete = null;
      }
    },

    downloadPicture(item) {
      let url;
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      let param;

      if (this.account != null && this.caseId != null && this.account != "") {
        url = "/DmConnection/DownloadAttachment";
        param = { value: item.id };

        axios
          .post(url, param, { responseType: "blob" })
          .then(files.getFile)
          .then((link) => {
            link.click();
          })
          .catch((e) => {
            this.$alertMsg(this.$t("messages.PhotoSaveError") + " - " + e, 4);
          })
          .finally(loader.hide());
      } else if (this.appId != null && this.appId != "") {
        //Application
        url = "/ActivityAttachment/Download";

        axios
          .get(url + "?attachmentId=" + item.attachmentId, {
            responseType: "blob",
          })
          .then(files.getFile)
          .then((link) => {
            link.click();
          })
          .catch((e) => {
            this.$alertMsg(this.$t("messages.PhotoSaveError") + " - " + e, 4);
          })
          .finally(loader.hide());
      }
    },
  },
};
